import styled, { css } from "styled-components";

const desktopMixin = css`
  margin-top: 0;
  margin-left: 2em;
`;

export const Container = styled.button`
  display: flex;
  padding: 1em;
  align-items: center;
  justify-self: center;
  color: #333;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;

  ${(props) => (props.desktop ? desktopMixin : "")}
`;
